<template>
  <v-autocomplete
    dense
    outlined
    clearable
    label="اسم المترجم"
    item-value="id"
    item-text="name"
    prepend-icon="mdi-translate"
    return-object
    :items="autocomplete.list"
    :loading="autocomplete.loading"
    :search-input.sync="autocomplete.searchInput"
    :value="autocomplete.record"
    @input="$emit('input', $event.id)"
    :error-messages="errors"
  >
    <template v-slot:item="data">
      <v-list-item-avatar>
        <img :src="data.item.image">
      </v-list-item-avatar>
      <v-list-item-title v-html="data.item.name"></v-list-item-title>
    </template>
  </v-autocomplete>
</template>


<script>
export default {
  name: 'translator-input',
  props: ['record', 'errors'],


  data: function () {
    return {
      autocomplete: {
        list: [],
        loading: false,
        searchInput: '',
        record: null
      }
    };
  },


  watch: {
    'record'(record) {
      if (record && record.translator_id) {
        this.autocomplete.list.push(record.translator);
        this.autocomplete.record = record.translator;
      }
    },

    'autocomplete.searchInput'(query) {
      query != '' && this.search(query);
    },

  },


  methods: {
    search(query) {
      this.autocomplete.loading = true;

      this.axios.get('/admin/translators', { params: { q: query } })
        .then((response) => {
          this.autocomplete.list = response.data.data;
        })
        .finally(() => {
          this.autocomplete.loading = false;
        });
    }
  }
}
</script>